<template>
	<div class="post-content">
		<slot></slot>
	</div>
</template>

<script>
export default{
	name: 'PostContent'
}
</script>


// WEBPACK FOOTER //
// src/assets/vue/components/Post/PostContent.vue